import { proxy, useSnapshot } from 'valtio';

type SelectedStudent = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  picture_url?: string;
  universal_student_identifier?: string;
} | null;

type SelectedEnrolment = {
  id: number;
  course: {
    id: string;
    identifier: string;
    title: string;
    coachingCallLink: string | null;
  };
} | null;

const bookCoachingCallState = proxy({
  isModalOpen: false,
  selectedStudent: null as SelectedStudent,
  setSelectedStudent: (student: SelectedStudent) => {
    if (student) {
      const { id, firstName, lastName, email, picture_url, universal_student_identifier } = student;
      bookCoachingCallState.selectedStudent = {
        id,
        firstName,
        lastName,
        email,
        picture_url: picture_url ?? '',
        universal_student_identifier: universal_student_identifier ?? '',
      };
    } else {
      bookCoachingCallState.selectedStudent = null;
    }
  },
  selectedEnrolment: null as SelectedEnrolment,
  setSelectedEnrolment: (enrolment: SelectedEnrolment) => {
    if (enrolment) {
      const { id, course } = enrolment;
      bookCoachingCallState.selectedEnrolment = {
        id,
        course: {
          id: course.id,
          identifier: course.identifier,
          title: course.title,
          coachingCallLink: course.coachingCallLink,
        },
      };
    } else {
      bookCoachingCallState.selectedEnrolment = null;
    }
  },
  resetStates: () => {
    bookCoachingCallState.selectedStudent = null;
    bookCoachingCallState.selectedEnrolment = null;
  },
  openModal: () => {
    bookCoachingCallState.selectedStudent = null;
    bookCoachingCallState.selectedEnrolment = null;
    bookCoachingCallState.isModalOpen = true;
  },
  closeModal: () => {
    bookCoachingCallState.isModalOpen = false;
  },
});

export function useBookCoachingCall() {
  const snap = useSnapshot(bookCoachingCallState);
  return {
    ...snap,
    state: bookCoachingCallState,
  };
}
